<div #reprocessModal class="ui tiny modal reprocess">
  <div class="modal-close close icon"></div>

  <h1>Reprocess Notices</h1>

  <div class="content">
    Are you sure you want to reprocess the
    {{ reprocessNotices?.length || 0 }} selected notice{{
      reprocessNotices?.length == 1 ? "" : "s"
    }}?
  </div>

  <div class="actions">
    <span class="go-back cancel">Cancel</span>
    <button
      class="ui primary background button"
      [ngClass]="{ disabled: processing }"
      (click)="confirmReprocessing()"
    >
      Confirm
    </button>
  </div>
</div>

<div #continueModal class="ui tiny modal reprocess">
  <div class="ui modal-close close icon"></div>

  <h1>Continue Processing Notice</h1>

  <div class="content">
    <p>Are you sure you want to continue processing the selected notice?</p>
    <p>
      Processing will continue at step
      <b>{{ continueNotice?.step?.nextStep?.name }}</b>
    </p>

    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button
        class="ui primary background button"
        [ngClass]="{ disabled: processing }"
        (click)="confirmContinue()"
      >
        Confirm
      </button>
    </div>
  </div>
</div>

<div #noticeFormModal class="ui tiny modal notice-form-modal">
  <div class="icon modal-close close"></div>

  <h1>{{ editingNoticeId ? "Edit notice" : "Add a new notice" }}</h1>

  @if (!showFullForm) {
  <div>
    @if (duplicateNotice) {
    <p class="error-message">
      <br />
      Notice already exists for document id #{{ checkingDocId }}.
    </p>
    } @if (duplicateNotice) {
    <p>
      Atlas ID: <strong>{{ duplicateNotice.atlasId }}</strong> &nbsp; &nbsp;
      Name: <strong>{{ duplicateNotice.partyEntityName }}</strong>
      <br />
      Notice Type: <strong>{{ duplicateNotice.noticeTypeName }}</strong>
    </p>
    }
    <div class="content">
      <label>
        Document Id
      </label>
      <input [(ngModel)]="checkingDocId" />
    </div>
    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button
        [disabled]="!checkingDocId"
        class="ui primary button"
        (click)="checkDocumentId(checkingDocId)"
      >
        Verify Document ID
      </button>
    </div>
  </div>
  } @if (noticeFormGroup && showFullForm) {
  <form [formGroup]="noticeFormGroup" (ngSubmit)="saveNotice()">
    <div class="content">
      @if (loadingDropdowns) {
      <div>
        <div class="ui active centered inline loader"></div>
      </div>
      } @if (!loadingDropdowns) {
      <div class="form-container">
        <div class="row">
          <label>
            {{ taxpayerAlias }} Name
            <input type="text" formControlName="partyEntityName" />
          </label>
          <label>
            Client
            <label>
              Document Id
              <input
                type="text"
                formControlName="documentId"
                [readonly]="!editingNoticeId"
              />
            </label>
          </label>
        </div>
        <div class="row">
          <app-search-dropdown
            [formCtrl]="noticeFormGroup.controls.noticeType"
            label="Notice Type"
            [listOptions]="noticeTypeListOptions"
          ></app-search-dropdown>
        </div>
        <div class="row">
          <app-search-dropdown
            [formCtrl]="noticeFormGroup.controls.noticeClientId"
            label="Client"
            [listOptions]="clientsList"
          ></app-search-dropdown>
          <label>
            Due Date
            <input
              type="date"
              [ngClass]="{
                'has-value': !!noticeFormGroup.get('dueDate').value
              }"
              formControlName="dueDate"
            />
          </label>
        </div>
        <div class="row">
          <label>
            Year
            <input type="text" formControlName="year" />
          </label>
          <app-search-dropdown
            [formCtrl]="noticeFormGroup.controls.period"
            label="Period"
            [listOptions]="periodListOptions"
          ></app-search-dropdown>
        </div>
        @if (!editingNoticeId) {
        <div class="row">
          <label>
            TFN
            <input type="text" formControlName="tfn" />
          </label>
          <label>
            ABN
            <input type="text" formControlName="abn" />
          </label>
        </div>
        }
        <div class="row">
          <label>
            Notice Date
            <input
              type="date"
              [ngClass]="{ 'has-value': !!noticeFormGroup.get('date').value }"
              formControlName="date"
            />
          </label>
        </div>
      </div>
      }
    </div>
    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button
        class="ui primary background button approve"
        [ngClass]="{ disabled: !noticeFormGroup.valid }"
      >
        {{ editingNoticeId ? "Save" : "Create" }}
      </button>
    </div>
  </form>
  }
</div>

<div #successModal class="ui tiny modal success-modal">
  <div class="icon modal-close close"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>{{ successMessage }}</h3>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">OK</div>
  </div>
</div>
